export const getCanonicalUrl = (uri?: string) => {
  const host = process.env.GATSBY_BLOG_CANONICAL_URL

  if (typeof window !== "undefined") {
    const { hostname, port, protocol } = window.location
    const formattedPort = port ? `:${port}` : ""
    return `${protocol}//${hostname}${formattedPort}${uri}`
  }

  return `${host}${uri}`
}
